<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>{{ 'staff' | t }}</label>
            <input class="form-control" v-model="filter.staff" />
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>{{ 'attr_name' | t }}</label>
            <input class="form-control" v-model="filter.attr_name" />
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>{{ 'old_value' | t }}</label>
            <input class="form-control" v-model="filter.old_value" />
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>{{ 'new_value' | t }}</label>
            <input class="form-control" v-model="filter.new_value" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
export default {
  props: ['value'],
  data: function () {
    return {
      filter: this.value
    };
  }
};
</script>
